import React, { FC } from "react";
import {
  CNavItem,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
} from "@coreui/react-pro";

import { StarterSidebarNav } from "./widgets/StarterSidebarNav";

import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";

import { logoNegative as starterLogo } from "../../../../assets/brand/coreui-logo-sidebar";
import { sygnet as starterCygnet } from "../../../../assets/brand/coreui-sygnet-sidebar";

// sidebar nav config
import navigation from "../../../configs/_starter.sidenav";
import { useStarterSidebarController } from "../controllers/useStarterSidebar";
import CIcon from "@coreui/icons-react";
import { cilShield } from "@coreui/icons-pro";
import { MainAppsRepo } from "../../../../Apps";

interface StarterSidebarProps {
  changeApp?: (app: MainAppsRepo) => void;
}

const StarterSidebar: FC<StarterSidebarProps> = (props) => {
  const {
    state: { sidebarShow, unfoldable },
    action: { setSidebarShow, toggleSidebarFold },
  } = useStarterSidebarController();

  const goToApp = () => {
    if (props.changeApp) {
      props.changeApp(MainAppsRepo.Starter);
    }
    return;
  };

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        setSidebarShow(visible);
      }}
    >
      <CSidebarBrand className="d-none d-md-flex">
        <CIcon className="sidebar-brand-full" icon={starterLogo} height={35} />
        <CIcon
          className="sidebar-brand-narrow"
          icon={starterCygnet}
          height={35}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar>
          <StarterSidebarNav items={navigation} />
        </SimpleBar>
        <CNavItem
          component={"div"}
          to="#"
          onClick={goToApp}
          className="mt-auto"
        >
          <CIcon icon={cilShield} customClassName="nav-icon" />
          Apps
        </CNavItem>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => {
          toggleSidebarFold();
        }}
      />
    </CSidebar>
  );
};

export default React.memo(StarterSidebar);
